import { render } from "./ProfileCard.vue?vue&type=template&id=d0db107a&scoped=true&ts=true"
import script from "./ProfileCard.vue?vue&type=script&lang=ts"
export * from "./ProfileCard.vue?vue&type=script&lang=ts"

import "./ProfileCard.vue?vue&type=style&index=0&id=d0db107a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0db107a"]])

export default __exports__